import _ from "lodash"
import React from "react"

import {
  IFieldValues,
  IPagesHistory,
  ISlotAvailabilitySelection
} from "../containers/selectionSlice"
import HistoryValueRow from "./HistoryValueRow"
import { PageId } from "../common/pageId"
import { PageContent } from "../common/pageText"
import { EditMode } from "../common/transaction"
import { IFieldConfig } from "../pages/Config"
import { AirportSeasonConfigurations } from "../api/AirportSeasonConfiguration"
import { useAppSelector } from "../app/hooks"

interface Props {
  editMode: EditMode
  airportSeasons: AirportSeasonConfigurations
  useICAOCode: boolean
  excludeConfig?: IFieldConfig
}

const SearchCriteria: React.FunctionComponent<Props> = ({
  editMode,
  excludeConfig,
  airportSeasons,
  useICAOCode
}) => {
  const { searchCriteria } = PageContent

  const { useLocalTime } =
    useAppSelector(
      (state) => state["selectionReducer"].airportSeasonsSelector
    ) || {}
  const historySelection: IPagesHistory = useAppSelector(
    (state) => state["selectionReducer"].pagesHistory
  )
  const slotAvailabilitySelector: ISlotAvailabilitySelection = useAppSelector(
    (state) => state["selectionReducer"].slotAvailabilitySelector
  )
  const pageHistory = historySelection[PageId.All]
  const isAvailability = editMode === EditMode.AVAILABILITY

  const handleGetRows = () => {
    let searchCriterias: IFieldValues[] = []

    if (isAvailability) {
      searchCriterias.push(slotAvailabilitySelector.values)
    } else {
      if (pageHistory) {
        const latestNewSearchIdx = _.findLastIndex(
          pageHistory.history,
          (h) => !h.addToQuery
        )
        searchCriterias = pageHistory.history.filter(
          (h, idx) => idx >= latestNewSearchIdx
        )
      }
    }

    return searchCriterias.map((h, idx) => {
      const _h = excludeConfig
        ? _.pickBy(h, (v, key) => !excludeConfig[key])
        : h

      if (useICAOCode) {
        const airportType = isAvailability ? "airport" : "airports"

        const t = _h[airportType].map((a) => {
          const airportSeason = airportSeasons.find((as) => as.airport === a)
          return airportSeason ? airportSeason.airportIcao : a
        })

        _h[airportType] = t
      }
      return (
        <HistoryValueRow
          key={idx}
          historyValues={_h}
          showSeasonTime={idx === 0}
          excludeFields={excludeConfig}
        />
      )
    })
  }

  return (
    <div className="ocs-search-criteria-container d-flex">
      <div className="ocs-mr-12">
        <p className="ocs-header-sm-grey">{searchCriteria}</p>
      </div>
      <div
        className={
          "ocs-search-history-rows" +
          (useLocalTime ? " ocs-local-time-history-rows" : "")
        }
      >
        {handleGetRows()}
      </div>
    </div>
  )
}

export default SearchCriteria
